
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Table } from 'typeorm';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { UpdateMSDCRequest } from 'src/app/core/models/transport-operation/update-msdc-request';
import { MSDCService } from 'src/app/features/transport-operation/services/msdc.service';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { DataTablePreference } from 'src/app/core/models/user-preference';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';


@Component({
  selector: 'laas-msdc-iqc',
  templateUrl: './msdc-iqc.component.html',
  styleUrls: ['./msdc-iqc.component.scss']
})
export class MSDCIQCComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.MSDCIQC;
  currentLang: string = this.laasSetting.language;
  @ViewChild('MSDCDataTable') dataTable!: Table;

  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;
  submitted: boolean = false;
  readonly preferenceKey: string = UserPreferenceConstants.MSDCIQC;

  searchForm: FormGroup;
  searchParams: UpdateMSDCRequest = new UpdateMSDCRequest();

  pageInfo: PageInfo;
  sortInfo: [{ property: string; direction: number }] | null;

  tableColumns: any[];
  showTableColumns: any[];
  tableValue: any[] = [];
  selectedRowId: any;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private msdcService: MSDCService
  ) {
    super(injector);
    const dataTablePreference = this.getDataTablePreference(this.preferenceKey);
    this.tableColumns = [
      { field: 'unSealDate', header: 'MSDCIQC.MainTable.UnSealDate', dataType: 'date', sort: false },
      { field: 'sealDate', header: 'MSDCIQC.MainTable.SealDate', dataType: 'date', sort: false },
      { field: 'epsHours', header: 'MSDCIQC.MainTable.EpsHours', sort: false },
      { field: 'remainHours', header: 'MSDCIQC.MainTable.RemainHours', sort: false },
      { field: 'unsealBy', header: 'MSDCIQC.MainTable.UnsealBy', sort: false },
      { field: 'sealBy', header: 'MSDCIQC.MainTable.SealBy', sort: false },
    ]

    this.showTableColumns = this.tableColumns;

    this.searchForm = this.formBuilder.group({
      scanId: [null, Validators.required],
      msdcType: "1",

    })

    this.pageInfo = {
      pageSize: 25,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };

    this.sortInfo = null;

  }

  async ngOnInit(): Promise<void> {

  }

  putRowId(array: any[]) {
    let rowId = 0;
    for (const val of array) {
      val.rowId = rowId;
      rowId = rowId + 1;
    }
  }

  get selectedColumns(): any[] {
    return this.showTableColumns;
  }

  set selectedColumns(cols: any[]) {
    this.showTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  get selectRow(): any {
    if (isNullOrEmpty(this.selectedRowId)) {
      return null;
    }
    return this.tableValue[this.selectedRowId];
  }

  set selectRow(rowData: any) {

    if (isNullOrEmpty(rowData)) {
      return;
    }

    if (isNullOrEmpty(this.selectedRowId)) {
      this.selectedRowId = rowData.rowId;
      return;
    }

    if (this.selectedRowId == rowData.rowId) {
      return;
    }

    this.selectedRowId = rowData.rowId;
  }

  confirmBtnClick(event: any) {
    this.pageInfo.pageIndex = 0;
    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }
    this.requestOfQuery();
  }

  resetClickBtn(event: Event): void {
    this.searchForm.reset({
      msdcType: "1"
    });
    this.ngOnInit();
  }


  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.requestOfQuery();
  }

  tableSort(event: any): void {
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.requestOfQuery();
  }

  async setPageSize(event: any): Promise<void> {
    this.pageInfo.pageSize = event.rows;
  }

  requestOfQuery(isQuery: boolean = true) {
    this.searchParams = deepCopy(this.searchForm.value);
    this.searchParams.userId = this.userService.userInfo.userName;

    this.searchParams.pageSize = this.pageInfo.pageSize;
    this.searchParams.pageIndex = this.pageInfo.pageIndex;
    this.searchParams.sortInfo = this.sortInfo;
    console.log("searchparams:" + JSON.stringify(this.searchParams));

    this.isLoading = true;

    this.selectedRowId = undefined;

    this.msdcService.updateMSDCData(this.searchParams)
      .subscribe({
        next: (result) => {
          const isSuccess = result.flag;

          if (!isSuccess) {
            this.toastErrorMessage(result.message);

            this.tableValue = [];
            this.pageInfo = {
              pageSize: 25,
              pageIndex: 0,
              totalRecords: 0,
              totalPages: 0,
            };

            return;
          }

          this.pageInfo.totalRecords = result.totalRecords;

          const msdcDatas = result.recordList;
          this.tableValue = msdcDatas.map((x: any) => {
            return x;
          });

          this.putRowId(this.tableValue);
          if (!isNullOrEmpty(result.message)) {
            //WMS若有回覆message就印出
            this.toastService.warn(result.message);
          }

        },
        error: (err) => {
          this.toastErrorMessage(err.error);

          this.tableValue = [];
          this.pageInfo = {
            pageSize: 25,
            pageIndex: 0,
            totalRecords: 0,
            totalPages: 0,
          };
        },
        complete: () => {
          this.isLoading = false;
          this.isSearchFormOpen = false;
        }
      });


  }

  get dataTablePreference(): DataTablePreference | null {
    return this.userService.preference.dataTablePreferences.find(x => x.tableName === this.preferenceKey) ?? null;
  }



}





